import { AddressType } from '../enums/address-type.enum';
import { EntityStatus } from '../enums/entity-status.enum';
import { IGeometry } from './geometry.interface';

export interface IAddress {
  addressUid?: string;
  addressLine1: string;
  addressLine2?: string;
  addressType: AddressType;
  city: string;
  postCode: string;
  country: string;
  countryName?: string;
  countrySubdivision?: string;
  timezone?: string;
  timezoneId?: string;
  formattedTimezone?: string;
  geometry?: IGeometry;
  status: EntityStatus;
}
